import Vue from 'vue';
import Vuex from 'vuex';
import { VuexPersistence } from 'vuex-persist';
import TelemetryStorePlugin from '@/store-services/telemetry';
import configStore from './config';
import { telemetryStore } from './telemetry';
import { apiStore } from './api';
import ApiStorePlugin from '../store-services/api';
import { staticDataStore } from './staticdata';
import StaticDataStorePlugin from '../store-services/staticdata';

Vue.use(Vuex);

const TOGGLE_EDIT = "TOGGLE_EDIT";
const TOGGLE_FULLSCREEN = "TOGGLE_FULLSCREEN";

const storePersist = new VuexPersistence<any>({
  storage: window.localStorage,
  modules: ['config'],
  reducer: (state) => ({ config: state.config })
});

export default new Vuex.Store({
  strict: false,
  state: {
    fullscreen: false,
    editMode: false,
    configureTile: 0
  },
  mutations: {
    RESTORE_MUTATION: storePersist.RESTORE_MUTATION,
    [TOGGLE_EDIT](state) {
      state.editMode = !state.editMode;
    },
    [TOGGLE_FULLSCREEN](state) {
      state.fullscreen = !state.fullscreen;
    }
  },
  actions: {
    toggleEditMode({ commit }) {
      commit(TOGGLE_EDIT);
    },
    toggleFullscreen({commit}) {
      commit(TOGGLE_FULLSCREEN);
    }
  },
  getters: {
    editModeState(state) {
      return state.editMode;
    },
    fullscreenState(state) {
      return state.fullscreen;
    }
  },
  modules: {
    config: configStore,
    telemetry: telemetryStore,
    staticdata: staticDataStore,
    api: apiStore
  },
  plugins: [
    storePersist.plugin,
    TelemetryStorePlugin,
    StaticDataStorePlugin,
    ApiStorePlugin
  ]
});
